import * as React from 'react';

import NotificationListItem from './NotificationListItem';

export default ({ notifications, onNotificationSelected, selectedNotificationId }) => {
    if (notifications.length === 0) {
        return (
            <div className="notification-list empty">
                {i18next.t('notifications.no_unread_left')}
            </div>
        );
    }

    return (
        <div className="notification-list">
            {
                notifications.map(notification =>
                    <NotificationListItem
                        key={notification.id}
                        notification={notification}
                        onNotificationClicked={id => onNotificationSelected(id)}
                        selected={selectedNotificationId === notification.id}
                    />
                )
            }
        </div>
    );
};
